import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import { navigate } from "../lib/router";
import TopBar from "../components/TopBar";
import { PROJECT_STATUS_LABEL, projectBadgeClass } from "../lib/format";
import AnalysisView from "../features/analysis/AnalysisView";
import SceneBoard from "../features/board/SceneBoard";
import ExportView from "../features/export/ExportView";

const TABS = [
  { key: "analysis", label: "Аналіз" },
  { key: "board", label: "Scene Board" },
  { key: "export", label: "Експорт" },
];

const ACTIVE_STATUSES = ["ingesting", "analyzing", "planning", "generating"];

export default function ProjectShell({ projectId, tab }: { projectId: string; tab: string }) {
  const project = useQuery({
    queryKey: ["project", projectId],
    queryFn: () => api.getProject(projectId),
    refetchInterval: (q) => {
      const data = q.state.data;
      if (!data) return false;
      const anyActive =
        ACTIVE_STATUSES.includes(data.status) ||
        data.scenes.some((s) => s.status === "frame_queued" || s.status === "video_queued");
      return anyActive ? 3500 : false;
    },
  });

  if (project.isLoading) {
    return (
      <>
        <TopBar crumbs={["Проєкти", "…"]} />
        <div className="content"><div className="empty"><span className="spinner" /></div></div>
      </>
    );
  }
  if (project.isError || !project.data) {
    return (
      <>
        <TopBar crumbs={["Проєкти", "Помилка"]} />
        <div className="content"><div className="empty">Проєкт не знайдено.</div></div>
      </>
    );
  }

  const p = project.data;

  return (
    <>
      <TopBar
        crumbs={[<span key="b" style={{ cursor: "pointer" }} onClick={() => navigate("/projects")}>Проєкти</span>, p.name]}
        right={<span className={"badge dot " + projectBadgeClass(p.status)}>{PROJECT_STATUS_LABEL[p.status]}</span>}
      />
      <div className="content">
        <div className="page-head">
          <div>
            <h1>{p.name}</h1>
            <div className="lead">
              {p.targetW}×{p.targetH} · 9:16 · {p.platform} · {p.progress.scenes} сцен ·{" "}
              {p.progress.videosReady}/{p.progress.aiScenes} відео готово
            </div>
          </div>
        </div>

        <div className="tabs">
          {TABS.map((t) => (
            <div
              key={t.key}
              className={"tab" + (tab === t.key ? " active" : "")}
              onClick={() => navigate(`/projects/${projectId}/${t.key}`)}
            >
              {t.label}
            </div>
          ))}
        </div>

        {tab === "analysis" && <AnalysisView project={p} />}
        {tab === "board" && <SceneBoard project={p} />}
        {tab === "export" && <ExportView project={p} />}
      </div>
    </>
  );
}
